import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import TemplateG from "@particles/card/templates/TemplateG/TemplateG";
import { useLoadMore } from "@routes/Hub/hooks/useLoadMore";

type HubBrandedContentArticlesProps = {
  /** The card props to be displayed in the component. */
  cardProps: ComponentProps<typeof Card>[];
  /** The class name to be applied to the component. */
  className?: string;
};

const HubBrandedContentArticles = ({
  cardProps,
  className,
}: HubBrandedContentArticlesProps): React.ReactElement => {
  const { ref, loadMoreData } = useLoadMore({
    initialList: cardProps,
    size: 10,
  });

  if (cardProps.length === 0) return <></>;

  return (
    <div
      className={className}
      data-testid="hub-branded-content-articles-component"
    >
      <BlockTitle
        text="BRANDED CONTENT"
        rootClassName="text-lg antialiased mb-4"
      />

      <TemplateG cardProps={[...cardProps, ...loadMoreData]} />

      <div ref={ref} />
    </div>
  );
};

export default HubBrandedContentArticles;
